import { render, staticRenderFns } from "./vipIndex.vue?vue&type=template&id=5ebf75d9&scoped=true"
import script from "./vipIndex.vue?vue&type=script&lang=js"
export * from "./vipIndex.vue?vue&type=script&lang=js"
import style0 from "./vipIndex.vue?vue&type=style&index=0&id=5ebf75d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf75d9",
  null
  
)

export default component.exports